import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import { ReservationFlowPaymentMethodListSubscription } from 'src/interfaces/reservation_flow';
import { RSBorderedListItemCollapsible } from 'src/reservation-page/bordered-list/RSBorderedListItemCollapsible';
import { RSLinkButton } from 'src/reservation-page/RSLinkButton';

export interface SubscriptionItemNotPurchasedProps {
  onRequireSubscriptionPurchasing: (productId: number) => void;
  paymentMethodsSubscription: ReservationFlowPaymentMethodListSubscription;
  isCollapsed: boolean;
  onRequireToggling: () => void;
}

export const SubscriptionItemNotPurchased: FC<
  SubscriptionItemNotPurchasedProps
> = ({
  onRequireSubscriptionPurchasing,
  paymentMethodsSubscription,
  isCollapsed,
  onRequireToggling,
}) => {
  const intl = useIntl();

  return (
    <RSBorderedListItemCollapsible
      leftContent={
        <div className="rs-font text-16 text-gray-1000 pc:text-15 font-bold">
          {intl.formatMessage({
            defaultMessage: '月謝',
            id: 'iTP5yt',
            description:
              'src/templates/merchants/resources/book/components/payment-method/SubscriptionItemNotPurchased/index.tsx',
          })}
        </div>
      }
      details={
        <div className="px-2.5 py-3">
          <ul className="list-style-none m-0 space-y-2.5 p-0">
            {paymentMethodsSubscription.products.map((product) => {
              return (
                <li
                  key={`paymentMethod_subscription_products_${product.public_id}`}
                  className="block"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex flex-auto items-center justify-between">
                      <div className="rs-font text-16 text-gray-1000 pc:text-15 font-normal">
                        {product.name}
                      </div>
                      <div className="rs-font text-13 text-gray-1000 pc:text-12 ml-1 font-normal">
                        {intl.formatNumber(product.price, {
                          style: 'currency',
                          currency: 'JPY',
                        })}
                      </div>
                    </div>

                    {product.is_published && (
                      <div className="rs-font text-16 pc:text-15 ml-1.5 flex-none font-normal">
                        <RSLinkButton
                          type="button"
                          onClick={() =>
                            onRequireSubscriptionPurchasing(product.public_id)
                          }
                        >
                          {intl.formatMessage({
                            defaultMessage: '購入',
                            id: 'QLzCij',
                            description:
                              'src/templates/merchants/resources/book/components/payment-method/SubscriptionItemNotPurchased/index.tsx',
                          })}
                        </RSLinkButton>
                      </div>
                    )}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      }
      isCollapsed={isCollapsed}
      isSelected={false}
      onClick={onRequireToggling}
      data-rsv-subscription="not-purchased"
    />
  );
};
